import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useCallback, useMemo } from 'react';
import { ListenerEvent, type ListenerEventType } from './constants';

type OnLoadPayload = {
  softpullSuccess: boolean;
  page: string;
};

function isOnLoadMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, OnLoadPayload> {
  return (
    message.event === ListenerEvent.OnLoad &&
    typeof message.payload.softpullSuccess === 'boolean' &&
    typeof message.payload.page === 'string'
  );
}

// doing nothing now since we are no longer showing recirc
function useHandleOnLoad(): (_payload: OnLoadPayload) => void {
  return useCallback((_payload: OnLoadPayload) => {}, []);
}

export default function useOnLoadHandler(): MessageHandler<
  ListenerEventType,
  OnLoadPayload
> {
  const handleOnLoad = useHandleOnLoad();

  return useMemo(
    () =>
      new MessageHandler(isOnLoadMessage, message => {
        handleOnLoad(message.payload);
      }),
    [handleOnLoad]
  );
}
